module.exports = __webpack_public_path__ + "static/media/builtinv2-mikrotik.ce21f868.png";